import React, { useState } from "react";
import { Button, Badge } from "@alifd/next";
import classnames from "classnames";
import { isEmpty } from "lodash";
import "./index.less";

const getLabel = (label, errorMsg) => {
  const realErrorMsg = isEmpty(errorMsg)
    ? "校验错误"
    : errorMsg.replace(/当前字段/, "");
  return realErrorMsg.includes(label)
    ? realErrorMsg
    : (label ? `${label}：${realErrorMsg}` : realErrorMsg);
};

export default function ErrorTab(props) {
  const { visible, errorList, globalErrorList, triggerScroll } = props;

  // 错误列表为空，或者visible为false，均不展示错误弹窗
  // globalErrorList 不为空，则需要展示错误弹窗
  const componentHidden =
    (!visible || isEmpty(errorList)) && isEmpty(globalErrorList);

  const scrollToError = (item) => {
    triggerScroll && triggerScroll(item.fieldId);
  };

  const count = isEmpty(errorList) ? null : errorList.length;

  return (
    <div
      className={classnames("c-error-tab__container", {
        hidden: componentHidden,
      })}
    >
      <Button className="c-error-tab__button" type="primary">
        校验清单
        {count && (
          <Badge
            style={{
              backgroundColor: "rgb(255, 195, 194)",
              marginLeft: "8px",
              fontWeight: 600,
            }}
            count={count}
          />
        )}
      </Button>
      <div className="c-error-tab__list-wrapper">
        <div className="c-error-tab__list">
          {!isEmpty(globalErrorList) &&
            globalErrorList.map((item) => (
              <li
                key={`global-${item.fieldId}`}
                className="c-error-tab__list__item-global"
                onClick={() => {
                  scrollToError(item);
                }}
              >
                {item.globalErrorMsg}
              </li>
            ))}
          {!isEmpty(errorList) &&
            errorList.map((item) => {
              return (
                <div
                  key={item.fieldId}
                  onClick={() => {
                    scrollToError(item);
                  }}
                  className="c-error-tab__list__item next-form-item-help"
                >
                  {getLabel(item.label, item.errorMsg)}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
